(function(){'use strict';

/* ═══ REVEAL ON SCROLL ═══ */
function initReveals(){
  var els = document.querySelectorAll('.muss-reveal, .muss-stagger');
  if(!els.length || !('IntersectionObserver' in window)) {
    els.forEach(function(el){ el.classList.add('is-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){
        e.target.classList.add('is-visible');
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });
  els.forEach(function(el){ obs.observe(el); });
}

/* ═══ ANIMATED COUNTERS ═══ */
function animateCounters(){
  document.querySelectorAll('[data-count]').forEach(function(el){
    var raw = el.getAttribute('data-count');
    var target = parseInt(raw, 10);
    if(isNaN(target)){ el.textContent = raw; return; }
    var suffix = el.getAttribute('data-suffix') || '';
    var dur = 1800;
    var start = null;
    function step(ts){
      if(!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 4);
      el.textContent = Math.floor(eased * target) + suffix;
      if(p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  });
}

function initCounters(){
  var stats = document.querySelector('.muss-stats');
  if(!stats || !('IntersectionObserver' in window)) return;
  var obs = new IntersectionObserver(function(entries){
    if(entries[0].isIntersecting){
      animateCounters();
      obs.unobserve(stats);
    }
  }, { threshold: 0.25 });
  obs.observe(stats);
}

/* ═══ SMOOTH SCROLL ═══ */
function initSmoothScroll(){
  document.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener('click', function(e){
      var href = a.getAttribute('href');
      if(href === '#') return;
      var t = document.querySelector(href);
      if(t){
        e.preventDefault();
        t.scrollIntoView({ behavior: 'smooth', block: 'start' });
        /* Move focus for accessibility */
        t.setAttribute('tabindex', '-1');
        t.focus({ preventScroll: true });
      }
    });
  });
}

/* ═══ INIT ═══ */
function init(){
  initReveals();
  initCounters();
  initSmoothScroll();
}

if(document.readyState === 'loading'){
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

})();
